import React from 'react';
import PropTypes from 'prop-types';

const SpacerComponent = ({
  when = true,
  top,
  right,
  bottom,
  left,
  children,
}) => {
  const style = {};

  if (!when) {
    return <>{children}</>;
  }

  if (top) {
    style.marginTop = `${top}px`;
  }

  if (right) {
    style.marginRight = `${right}px`;
  }

  if (bottom) {
    style.marginBottom = `${bottom}px`;
  }

  if (left) {
    style.marginLeft = `${left}px`;
  }

  return <div style={style}>{children}</div>;
};

SpacerComponent.propTypes = {
  when: PropTypes.bool,
  children: PropTypes.node,
  top: PropTypes.number,
  right: PropTypes.number,
  bottom: PropTypes.number,
  left: PropTypes.number,
};

export default SpacerComponent;
